module.exports = __webpack_public_path__ + "static/m_solution11-bfca12fc1eb0171e21de163dd0ffb365.png";